import React from "react";
import { HOLTER, HOLTER_PRICES } from "../../data/fees";

export const HolterDays = ({ reasons, value, onChange }) => {
  if (!reasons.includes(HOLTER)) return null;
  return (
    <div data-testid="holter-days" className="p-5 bg-white border border-stone-200/60 rounded-md">
      <label htmlFor="holter-days-select" className="text-sm font-medium text-ink">How many days of ambulatory ECG (Holter) monitoring?</label>
      <p className="text-xs text-ink-muted mt-1">If your doctor has asked for a specific length, choose that. The monitor is fitted at your visit and you return it afterwards.</p>
      <select id="holter-days-select" data-testid="holter-days-select" value={value} onChange={(e) => onChange(Number(e.target.value))}
        className="mt-3 rounded-sm border border-stone-300 bg-white px-3 py-2 text-sm">
        {Object.keys(HOLTER_PRICES).map(Number).map((d) => (
          <option key={d} value={d}>{d === 1 ? "24 hours (1 day)" : `${d} days`}</option>
        ))}
      </select>
    </div>
  );
};
